import { makeDefaultTypographyStyled } from '../typography-styled';

export const StyledText = makeDefaultTypographyStyled('Text', 'span', 1, 1.46);
